import { ToastOptions } from 'react-toastify';

export const toastOption: ToastOptions = {
  position: 'top-right',
  autoClose: 4000,
  pauseOnHover: true,
  draggable: true,
  theme: 'dark'
};
